
<template>

	<div>
		<b-row>
			<b-col>
				<b-table style="font-size: 10pt;" small :items="stats" :fields="stats_fields" class="mt-2"/>
			</b-col>
			<b-col>
				<b-table style="font-size: 10pt;" small :items="correlation" :fields="correlation_fields" class="mt-2">
					<template #head()="data">
						<div
							:id="'popover-target-field-' + data.label"
							style="width: 100%;height: 100%;"
						>
							{{ data.label }}
						</div>
						<b-popover
							:target="'popover-target-field-' + data.label"
							triggers="hover"
							placement="bottom"
							:container="'popover-target-field-' + data.label"
						>
							{{ data.field.name }}
						</b-popover>
					</template>

					<template #cell(ind)="cell_data">
						<div
							:id="'popover-target-item-' + cell_data.value"
							style="width: 100%;height: 100%;"
						>
							{{ cell_data.value }}
						</div>
						<b-popover
							:target="'popover-target-item-' + cell_data.value"
							triggers="hover"
							placement="right"
							:container="'popover-target-item-' + cell_data.value"
						>
							{{ cell_data.item.name }}
						</b-popover>
					</template>

					<template #cell()="cell_data">						
						<div
							:id="'popover-target-' + cell_data.value.attr_1.ind + cell_data.value.attr_2.ind"
							style="width: 100%;height: 100%;"
						>
							{{ cell_data.value.correlation }}
						</div>
						<b-popover
							:target="'popover-target-' + cell_data.value.attr_1.ind + cell_data.value.attr_2.ind"
							triggers="hover"
							placement="bottom"
							:container="'popover-target-' + cell_data.value.attr_1.ind + cell_data.value.attr_2.ind"
						>
							{{ cell_data.value.attr_1.ind }}: {{ cell_data.value.attr_1.name }}<br/>
							{{ cell_data.value.attr_2.ind }}: {{ cell_data.value.attr_2.name }}<br/>
							Корреляция:  {{cell_data.value.correlation }}
						</b-popover>
					</template>
				</b-table>
				<b-row class="legend">
					<b-col class="d-flex align-items-center" style="gap: 1rem;">
						<div class="good_value color"></div><span>Слабая зависимость (до 0,3)</span>
					</b-col>
					<b-col class="d-flex align-items-center" style="gap: 1rem;">
						<div class="middle_value color"></div><span>Средняя зависимость (от 0,3 до 0,7)</span>
					</b-col>
					<b-col class="d-flex align-items-center" style="gap: 1rem;">
						<div class="bad_value color"></div><span>Сильная зависимость (от 0,7 до 1)</span>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
	</div>

</template>

<script>

import api from "../../../../../../api"
// import myframe from "../../../../../widgets/frame"
import o from "./../objects"

export default
{
	props :
	{
		id : String,
		group_id : String,
		data : Object,
	},

	components :
	{
		// myframe,
	},

	mounted()
	{
		o.objects().bus.$on("update_plots", () => this.refresh())

		this.refresh()
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			correlation : [],
			correlation_fields : [],

			stats : [],
			stats_fields :
			[
				{ key : "ind", label : "X", thStyle : "min-width: 60px;" },
				{ key : "attr", label : "Ценообразующий фактор", thStyle : "min-width: 100px;" },
				{ key : "min", label : "Минимум", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "max", label : "Максимум", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "variance", label : "Дисперсия", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "excess", label : "Эксцесс", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "average", label : "Среднее", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "median", label : "Медиана", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "moda", label : "Мода", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "asymmetry", label : "Асимметрия", thStyle : "min-width: 100px;", tdClass : "text-right" },
				{ key : "standard_deviation", label : "Стандартное отклонение", thStyle : "min-width: 100px;", tdClass : "text-right" },
			],

		}
	},

	methods :
	{
		refresh()
		{
			var correlations = {}
			var promises = []

			this.data.attrs.forEach(
				( attr, ind ) =>
				{
					correlations[attr.id] = {}
					attr.cor_ind = ind
				})

			this.data.attrs.forEach(
				attr =>
					this.data.attrs.forEach(
						attr_2 =>
						{
							if(attr.cor_ind <= attr_2.cor_ind)
								promises.push(o.objects().correlation(attr, attr_2).then(
									correlation =>
									{
										correlations[attr.id][attr_2.id] = correlation
										correlations[attr_2.id][attr.id] = correlation
									}))
						})
				)

			Promise.all(promises)
				.then(
					() =>
						api.call(this, this.service, "get_attrs_stat", { id : this.id },
							response =>
							{
								const stat = response.stat
								var stats = []
								var correlation = []
								var correlation_fields = [ { key : "ind", label : "", thStyle : "width: 60px;" } ]

								this.data.attrs.forEach(
									attr =>
									{	
										correlation_fields.push(
											{
												key : attr.id,
												label : attr.ind,
												name : attr.name,
												thStyle : "min-width: 100px;",
												tdClass :
													value =>
													{
														const value_abs = Math.abs(value.correlation)

														if(value_abs < 0.3)
															return "text-right good_value"
														else if(value_abs < 0.7)
															return "text-right middle_value"
														
														return "text-right bad_value"
													}
											})											
										
										if(attr.type == "number")
										{
											stats.push(
												{
													ind : attr.ind,
													attr : attr.name,
													variance : api.round5(stat.variance[attr.id]),
													excess : api.round5(stat.excess[attr.id]),
													average : api.round5(stat.average[attr.id]),
													median : api.round5(stat.median[attr.id]),
													moda : api.round5(stat.moda[attr.id]),
													asymmetry : api.round5(stat.asymmetry[attr.id]),
													standard_deviation : api.round5(stat.standard_deviation[attr.id]),
													min : api.round5(stat.min[attr.id]),
													max : api.round5(stat.max[attr.id]),
												})
										}
										// else // 3716 п. 41
										// {
										// 	stats.push(
										// 		{
										// 			ind : attr.ind,
										// 			attr : attr.name,
										// 			variance : "-",
										// 			excess : "-",
										// 			average : "-",
										// 			median : "-",
										// 			moda : "-",
										// 			asymmetry : "-",
										// 			standard_deviation : "-",
										// 			min : stat.min[attr.id],
										// 			max : stat.max[attr.id],
										// 		})
										// }

										var elem = { 
											ind : attr.ind,
											name : attr.name,
										}
										
										this.data.attrs.forEach(
											attr_2 =>
											{
												elem[attr_2.id] = 
												{
													correlation : correlations[attr.id][attr_2.id],
													attr_1 :
													{
														ind : attr.ind,
														name : attr.name,
													},
													attr_2 : 
													{
														ind : attr_2.ind,
														name : attr_2.name,
													},
												}
											})
											
										correlation.push(elem)
									})

								this.correlation = correlation
								this.correlation_fields = correlation_fields
								this.stats = stats
							})
				)
		},
	}
}

</script>

<style>

.bad_value
{
	background-color: pink;
}

.middle_value
{
	background-color: #ffff9b;
}

.good_value
{
	background-color: #c2ffc2;
}
.legend .color
{
	display: inline-block;
	height: 2rem;
	width: 2rem;
}

</style>

